import React from 'react'
import {Icon} from '@chakra-ui/react'

const GuaranteedIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_31_617)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.0001 1.15616C24.9165 1.11251 29.787 2.10656 34.2932 4.07343L34.3175 4.08431C34.982 4.38849 35.5444 4.87815 35.9371 5.49439C36.3288 6.10902 36.5351 6.82345 36.5313 7.55217V19.2862C36.5313 23.2996 35.3151 27.2188 33.043 30.5272C30.7709 33.8356 27.5497 36.3778 23.8039 37.8187L22.1989 38.4354C22.1988 38.4355 22.1991 38.4353 22.1989 38.4354C20.7838 38.9796 19.2167 38.9797 17.8017 38.4356C17.8015 38.4355 17.8018 38.4356 17.8017 38.4356L16.1968 37.8189C12.451 36.378 9.22917 33.8356 6.95711 30.5272C4.68504 27.2188 3.46884 23.2996 3.4688 19.2862V7.55231C3.46501 6.82353 3.67129 6.10905 4.06301 5.49439C4.45574 4.87815 5.01815 4.38849 5.68259 4.08431L5.70692 4.07343C10.2131 2.10656 15.0836 1.11251 20.0001 1.15616ZM6.92226 6.81629C6.78738 6.88011 6.67319 6.98075 6.59292 7.1067C6.51086 7.23547 6.46775 7.38521 6.46877 7.5379L6.46883 7.54793L6.4688 19.2862C6.46883 22.6932 7.50129 26.0203 9.43008 28.8288C11.3588 31.6372 14.0931 33.7952 17.2728 35.0185C17.2726 35.0185 17.273 35.0186 17.2728 35.0185L18.8777 35.6352C19.5998 35.913 20.3998 35.9131 21.1219 35.6354L22.7268 35.0187C22.7266 35.0188 22.7269 35.0187 22.7268 35.0187C25.9064 33.7955 28.6413 31.6372 30.57 28.8288C32.4988 26.0203 33.5313 22.6932 33.5313 19.2862V7.5379C33.5323 7.3852 33.4892 7.23547 33.4072 7.1067C33.3269 6.98075 33.2127 6.88011 33.0778 6.81629C28.9588 5.02094 24.5073 4.11448 20.014 4.15616H19.9861C15.4929 4.11448 11.0414 5.02094 6.92226 6.81629Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M29.0235 15.0966L17.2858 26.0519L11.9766 21.0966L14.0235 18.9034L17.2858 21.9482L26.9766 12.9034L29.0235 15.0966Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_31_617">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.000366211)"
                    />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default GuaranteedIcon
